import compact from 'lodash/compact';

const SEPARATOR = '/';

/**
 *
 * @param {string} product
 * @param {string} motive
 *
 * @returns {string} - retorna un string del estilo PRODUCT/MOTIVO o solo PRODUCT dependiendo del caso
 */
export const stringify = (product, motive) => compact([product, motive]).join(SEPARATOR);

export const parse = value => {
  const [product, motive] = value.split(SEPARATOR);

  return { product, motive };
};

export default { stringify, parse };
